import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { inverted, maxWidth })=>({
        tooltip: {
            backgroundColor: inverted ? theme.tokens.colors.bg.light.primary : theme.tokens.colors.bg.dark.primary,
            color: inverted ? theme.tokens.colors.text.light.primary : theme.palette.common.white,
            fontSize: theme.tokens.typography.variant.caption.fontSize,
            lineHeight: theme.tokens.typography.variant.caption.lineHeight,
            padding: theme.tokens.spacing['12'],
            borderRadius: theme.tokens.radius.l,
            [theme.breakpoints.down('sm')]: {
                maxWidth: maxWidth || theme.px(235),
                '&.MuiTooltip-tooltipPlacementBottom': {
                    marginTop: theme.px(12)
                },
                '&.MuiTooltip-tooltipPlacementTop': {
                    marginBottom: theme.px(12)
                },
                '&.MuiTooltip-tooltipPlacementLeft': {
                    marginRight: theme.px(12)
                },
                '&.MuiTooltip-tooltipPlacementRight': {
                    marginLeft: theme.px(12)
                }
            },
            [theme.breakpoints.up('md')]: {
                maxWidth: maxWidth || theme.px(310)
            }
        },
        arrow: {
            color: inverted ? theme.tokens.colors.bg.light.primary : theme.tokens.colors.bg.dark.primary
        },
        [theme.breakpoints.down('sm')]: {
            popper: {
                paddingLeft: theme.px(10),
                paddingRight: theme.px(10),
                '& .MuiTooltip-arrow': {
                    transform: `translateX(-${theme.px(10)}px)`
                }
            }
        }
    }));
const Tooltip_styles = useStyles;
export default Tooltip_styles;
